import { useSession } from 'next-auth/react';
import LogoutButton from './LogoutButton';
import SignInButton from './SignInButton';

export default function AuthStatus({ singInCallbackUrl, logoutCallbackUrl }: { singInCallbackUrl?: string; logoutCallbackUrl?: string }) {
    const { status, data: session } = useSession();
    const isUserLoggedIn = status === 'authenticated';

    return (
        <>
            {isUserLoggedIn ? (
                <div className="flex items-center gap-2">
                    <p className="inline-block text-stone-800">
                        Welcome, <span className="font-bold">{session?.user?.name}</span>
                    </p>
                    <LogoutButton callbackUrl={logoutCallbackUrl} />
                </div>
            ) : (
                <SignInButton callbackUrl={singInCallbackUrl} />
            )}
        </>
    );
}
